/* eslint-disable no-shadow */
export default (action, wait) => {
	const debounce =
		typeof window !== 'undefined' && window._ && window._.debounce
			? window._.debounce
			: (action, wait) => {
					// fallback if underscore is not loaded
					let timeoutId;
					return function debouncer() {
						clearTimeout(timeoutId);
						timeoutId = setTimeout(action, wait);
					};
			  };
	return debounce(action, wait);
};
